import axios from 'axios';

async function getConvertkitTags(key: string) {
  const url = `https://api.convertkit.com/v3/tags?api_key=${key}`;
  return await axios.get(url);
}

export { getConvertkitTags };
